<template>
  <ErrorBoundary>
    <component
      :is="blocksMap[componentType as keyof typeof blocksMap]"
      :content="content"
      v-bind="blockProps"
      @open-contact-form="(plan: any) => emit('openContactForm', plan)"
      @open-case-study-form="emit('openCaseStudyForm')"
    ></component>
  </ErrorBoundary>
</template>

<script setup lang="ts">
import { blocksMap } from './blocksMap'

defineProps<{
  content: any
  componentType: string
  /**
   * Per-page overrides forwarded to the resolved block component. Pass only
   * props the target block declares — anything else lands as a DOM attribute.
   */
  blockProps?: Record<string, unknown>
}>()

const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])
</script>
